export default {
  message: {
    pwa: {
      installDisclaimer: "A new version is available",
      installButton: "Install",
      cancelButton: "Dismiss",
    },
    hello: "Good morning",
    yes: "Yes",
    no: "No",
    error: {
      generic: "An error has occurred",
      noAuthorizated: "Unauthorized user",
      fieldRequired: "Required field",
      fieldMin: "You must enter at least {min} characters",
      fieldMax: "You can enter a maximum of {max} characters",
      fieldEmail: "The email is not valid",
      fieldNumber: "The value must be a number",
      fieldInteger: "The value must be an integer",
      fieldNumberMin: "Must be greater than or equal to {min}",
      fieldNumberExclusiveMin: "Must be greater than {min}",
      fieldNumberMax: "Must be less than or equal to {max}",
      fieldNumberExclusiveMax: "Must be less than {max}",
      noSpaces: "Cannot contain spaces",
      invalidPassword: "The password cannot contain spaces",
      distinctPassword: "The passwords do not match",
      invalidFile: "The file is incorrect",
      invalidImageFileType: "The file must be jpg, jpeg or png",
      fileSizeMax: "The file must be less than 500kb",
    },
    vModal: {
      confirm: "Confirm",
      cancel: "Cancel",
    },
    login: {
      info: {
        disclaimer: "For any enquiry please contact",
      },
      loginPage: {
        email: "Email",
        password: "Password",
        login: "Sign in",
        loginWithGoogle: "Sign in with Google",
        signup: "Sign up",
        forgotPassword: "I forgot my password",
        error: "Incorrect credentials",
        googleErrorEmailExists:
          "This email is already registered. Sign in with your email and password.",
        googleErrorCancelled: "Google sign-in cancelled.",
        googleError:
          // eslint-disable-next-line max-len
          "Google sign-in could not be completed. If you already have an account, sign in with your email and password.",
        textDonate: "Donate",
      },
      signupPage: {
        headerTitle: "New user",
        back: "Back",
        email: "Email",
        password: "Password",
        confirmPassword: "Repeat password",
        alias: "Alias",
        name: "Name",
        surname: "Surname",
        signup: "Sign up",
        login: "I already have an account",
        verificationCode: "Verification code",
        error: "Registration could not be completed",
        textDisclaimerSpam: `If you do not receive the email with the verification code, 
        please check your spam folder`,
      },
      passwordRecoveryPage: {
        headerTitle: "Recover password",
        back: "Back",
        email: "Email",
        password: "New password",
        confirmPassword: "Repeat password",
        verificationCode: "Verification code",
        confirm: "Confirm",
        error: "The password could not be changed",
        errorGoogleUser:
          "Your account uses Google Sign-In. Manage your password from your Google account.",
        textDisclaimerRestartPassword: `If you do not receive the password reset email, 
        please check your spam folder`,
      },
    },
    userDashboard: {
      tabs: {
        groups: "Groups",
        competitions: "Competitions",
        matches: "Matches",
        account: "Account",
        admin: "Admin",
      },
      userGroups: {
        headerTitle: "Groups",
      },
      userCompetitions: {
        headerTitle: "Competitions",
        notFinished: "Ongoing",
        finished: "Finished",
        noCompetitions: "No competitions to show",
      },
      userMatches: {
        headerTitle: "Matches",
        filterCompetition: "Filter by competition",
        filterStatus: "Filter by status",
        allCompetitions: "All competitions",
        allStatuses: "All",
        statusNotFinished: "Not finished",
        statusUpcoming: "Upcoming",
        statusActive: "Live",
        statusFinished: "Finished",
        noMatches: "No matches to show",
        cancel: "Cancel",
        resultTitle: "Final Result",
        activeTitle: "Match in Progress",
        betsPageTitle: "My Bets",
        noBetGroups: "You have no groups in this competition",
        noBetsForGroup: "No bets registered",
        myBet: "Your bet",
        matchStarted: "This match has already started, no bets can be placed",
        saveBet: "Save bet",
        betSaved: "Bet saved successfully",
        summaryVideo: "Match summary",
      },
      userAccount: {
        headerTitle: "Account",
      },
    },
    accountHome: {
      accountInfo: {
        karma: "Karma",
        name: "Name",
        surname: "Surname",
        email: "Email",
        phone: "Phone",
        pushNotifications: "Push notifications",
        enablePush: "Enable notifications",
        pushEnabled: "Notifications active",
        pushEnabledDescription: "This device is already subscribed and can receive alerts.",
        pushEnabledToast: "Notifications enabled successfully",
        pushDisabledToast: "Push notifications disabled for your account",
        pushInactive: "Notifications pending activation",
        pushInactiveDescription: "Enable the option and grant permission to register this device.",
        pushActionRequired: "Prior action required",
        pushBlocked: "Permission blocked",
        pushBlockedDescription:
          "You have blocked notifications in the browser or system. " +
          "You must re-enable them from settings.",
        pushDisabledByProfile: "Notifications disabled on your account",
        pushDisabledByProfileDescription:
          "Your user does not have push notifications enabled on the server.",
        pushEnableError: "Could not enable notifications on this device",
        pushSettingsUpdateError: "Could not save notification settings",
        logout: "Sign out",
        edit: "Edit",
        textDonate: "Donate",
        language: "Language",
      },
      accountEditInfo: {
        headerTitle: "Edit info",
        confirm: "Confirm",
        name: "Name",
        surname: "Surname",
        alias: "Alias",
        aliasRegexError: "The alias must be a single word",
        error: "Error editing information",
        error409: "Error: That alias already exists",
        altAvatar: "User Avatar",
      },
    },
    createGroup: {
      createGroupView: {
        headerTitle: "New group",
        create: "Create",
        join: "Join",
      },
      selectCompetitionForm: {
        title: "Select a competition",
      },
      groupForm: {
        title: "Group details",
        name: "Name",
        description: "Description",
        visible: "Visible result",
        repetition: "Allow repetition",
        submit: "Create group",
      },
    },
    groupHome: {
      groupHomeTabs: {
        classification: "Standings",
        bets: "Bets",
        chat: "Chat",
        messageInfoGroup: "Tap to view group info",
      },
      groupJoin: {
        codeInvitation: "Invitation code",
        confirm: "Confirm",
        submit: "Join",
        errorJoin: "Error joining the group. Please check your code",
      },
      groupInfo: {
        headerTitle: "Group info",
        modalCancelLabel: "Back",
        modalEditLabel: "Edit",
        addDescription: "Add description",
        rules: "Rules",
        settings: "Settings",
        players: "Players",
        exit: "Leave group",
        confirmExit: `Are you sure you want to leave the group? 
            This action will remove all your current bets in the group`,
        warning: "Warning",
        modal: {},
        exitGroup: "Leave",
        archiveGroup: "Archive",
        confirmArchive: "Are you sure you want to archive this group?",
      },
      groupInfoEdit: {
        headerTitle: "Group info",
        confirm: "Confirm",
        name: "Name",
        description: "Description",
        altAvatar: "User Avatar",
      },
      playersInfo: {
        headerTitle: "Players",
        search: "Search",
        addPlayer: "Add player",
        admin: "Admin",
        you: "You",
        active: "Active",
        inactive: "Inactive",
        doAdmin: "Make admin",
        doAdminHeader: "Attention!",
        doAdminMessage: "You are about to make this player an admin of the group",
        doAdminError: "Error making player admin",
        doAdminSuccess: "Admin added",
        decline: "Remove",
        declineHeader: "Attention!",
        declineMessage: "You are about to remove the player from the group, continue?",
        invitationGroup: "Group invitation link",
        declineError: "Error removing player",
        declineSuccess: "Player removed",
      },
      rulesInfo: {
        headerTitle: "Rules",
        points: "Points",
        factor: "Factor",
        placeholder: "Select a team",
        cancel: "Cancel",
        ok: "Accept",
        subHeader: "Select the Bonus team",
        placeholderRound: "Select a round",
        subHeaderRound: "Select the Bonus round",
        roundCategory: {
          groups: "GROUP STAGE",
          eightfinal: "ROUND OF 16",
          quaterfinal: "QUARTER-FINALS",
          semifinal: "SEMI-FINALS",
          final: "FINAL",
          thirdplace: "THIRD PLACE",
        },
      },
      groupChat: {
        headerTitle: "Chat",
        join: "Join Telegram chat",
      },
      addPlayer: {
        headerTitle: "Add player",
        search: "Search",
        add: "Add",
        confirm: "Confirm",
        registered: "Already participating",
      },
      invitationGroup: {
        headerTitle: "Invitation link",
        share: "Share",
        copy: "Copy",
        message: `Any user with this link will be able to join the group.`,
        name: "Invitation code",
        copyMessageSuccess: "Code copied",
        copyMessageError: "Error copying code",
      },
      classification: {
        points: "pts",
        first: "Race leader",
        second: "Chaser",
        penultimate: "Peloton",
        last: "Lantern rouge",
        defaultpos: "Peloton",
      },
      bets: {
        headerTitle: "Bets",
        pts: "pts",
        mybet: "My bet",
        bet: "Bet",
        noDate: "No date",
        betscla: "Bets by",
        cancel: "Cancel",
        all: "All",
        finished: "Finished",
        notFinished: "Not finished",
        pending: "Pending",
        placeholder: "Match filter",
        messageNoDataClassiBets: "This player has not placed any bets yet",
        messageNoDataMatchBets: "No matches found for that filter",
      },
      betModal: {
        cancel: "Cancel",
        confirm: "Confirm",
        bet: "Bet",
        messageNoBets:
          "When the match starts you will be able to see the rest of the group's bets here",
        stats: "Statistics",
      },
      group: {
        cancel: "Cancel",
        all: "All",
        archived: "Archived",
        actived: "Active",
        placeholder: "Group filter",
        messageNoDataGroup: "No groups found for that filter",
      },
    },
    competitionHome: {
      competitionHomeTabs: {
        teams: "Teams",
        matches: "Matches",
      },
      competitionInfo: {
        headerTitle: "Competition info",
      },
      messageInfoCompetition: "Tap to view competition info",
    },
    admin: {
      headerTitle: "Administration",
      noDate: "No date",
      list: {
        competitions: "Competitions",
        notifications: "Push Notifications",
        syncConfigs: "Sync config management",
        stats: "Statistics",
        summaryVideos: "Summary videos",
      },
      dashboard: {
        welcome: "Admin Panel",
        subtitle: "Manage competitions and send notifications to users",
        competitionsDescription: "Manage competitions, matches and teams",
        notificationsDescription: "Send push notifications to all users",
        syncConfigsDescription: "Create and delete external sync configurations",
        statsDescription: "Review global metrics for users, groups and activity",
        summaryVideosDescription: "Add the YouTube URL of each match's summary video",
      },
      summaryVideos: {
        headerTitle: "Summary videos",
        competition: "Competition",
        selectCompetition: "Select a competition",
        hint: "Tap a match to add or edit its summary video URL.",
        empty: "No matches in this competition",
        vs: "vs",
        withVideo: "With video",
        noVideo: "No video",
        urlLabel: "Video URL (YouTube)",
        valid: "Valid YouTube URL",
        invalid: "Must be a YouTube URL (youtube.com or youtu.be)",
        save: "Save",
        saved: "Summary video saved",
        saveError: "Could not save the summary video",
      },
      stats: {
        headerTitle: "Statistics",
        heroLabel: "Global overview",
        heroSubtitle: "registered users on the platform",
        heroSummary: "registered users · {active} active",
        refresh: "Refresh",
        retry: "Retry",
        errorTitle: "Statistics could not be loaded",
        error: "An error occurred while loading the statistics",
        loading: "Loading statistics",
        neverUpdated: "Not updated yet",
        updatedAt: "Updated {value} ago",
        labels: {
          active: "Active",
          activeGroups: "Active groups",
          activeUsers: "Active users",
          activeUsersInActiveGroups: "Active in active groups",
          googleUsers: "Google users",
          maxScore: "Max score",
          meanScore: "Average score",
          medianScore: "Median",
          minScore: "Min score",
          newUsers: "New users (last 24h)",
          pushEnabledUsers: "Push enabled",
          totalBets: "Bets",
          totalCompetitions: "Competitions",
          totalMatches: "Matches",
          totalTeams: "Teams",
          usersWithAvatar: "With avatar",
          usersWithBets: "With bets",
          totalPlayers: "Total players",
          scoreRange: "Range {min}-{max} pts",
        },
        kpis: {
          groups: "Groups",
          users: "Users",
          playersPerGroup: "Players per group",
          pendingMatches: "Pending matches",
          activeOfTotal: "{active} active out of {total}",
          totalPlayers: "{total} total players",
          totalMatches: "{total} total matches",
          totalPlayersCaption: "{total} group subscriptions",
          playersPerGroupCaption: "players / group on average",
          allMatchesPlayed: "All matches already played",
          pendingMatchesCaption: "Pending out of {total} matches",
        },
        sections: {
          usersBreakdown: "User breakdown",
          users: {
            title: "Users",
            subtitle: "Activity and adoption",
          },
          players: {
            title: "Players",
          },
          ecosystem: {
            title: "Catalog",
            subtitle: "Competitions and volume",
          },
          classification: {
            title: "Classification",
            subtitle: "Score distribution",
          },
        },
      },
      competitions: {
        headerTitle: "Competitions",
        emptyState: "No competitions available",
        deleteAll: "Delete all",
        create: {
          title: "Create Competition",
        },
        delete: {
          button: "Delete",
          warning: "Warning",
          confirmOne: "Are you sure you want to delete the competition {name}?",
          confirmAll: "Are you sure you want to delete all competitions?",
          success: "Competition deleted successfully",
          successAll: "Competitions deleted successfully",
          error: "Error deleting competition",
          errorAll: "Error deleting competitions",
        },
      },
      competition: {
        matchs: {
          title: "Matches",
          modalTitle: "Edit match",
          submitMatch: "Confirm",
        },
        teams: {
          title: "Teams",
        },
      },
      teams: {
        headerTitle: "Teams",
        modal: {
          create: "Create Team",
          edit: "Edit Team",
          name: "Name",
        },
      },
      notifications: {
        headerTitle: "Push Notifications",
        title: "Title",
        titlePlaceholder: "Enter the notification title",
        message: "Message",
        messagePlaceholder: "Enter the notification message",
        url: "Link (optional)",
        sendButton: "Send to all users",
        lastResult: "Last result",
        successMessage: "Notification sent successfully",
        errorMessage: "Error sending notification",
        emojiPicker: {
          title: "Select an emoji",
        },
      },
      syncConfigs: {
        headerTitle: "Sync config management",
        emptyState: "No sync configurations available",
        enabled: "Enabled",
        disabled: "Disabled",
        unknownCompetition: "Unknown competition",
        create: {
          title: "Create Sync Config",
          competitionSection: "Competition",
          competitionName: "Name",
          competitionCaption: "Caption",
          competitionDescription: "Description",
          competitionStartTime: "Start date",
          competitionEndTime: "End date",
          syncConfigSection: "Sync config",
          label: "Label",
          externalId: "Competition External ID",
          season: "Season",
          submit: "Create",
          success: "Sync config created successfully",
          error: "An error occurred while creating the sync config",
          endTimeAfterStartTime: "The end date must be after the start date",
        },
        delete: {
          button: "Delete",
          success: "Sync config deleted successfully",
          error: "An error occurred while deleting the sync config",
        },
      },
    },
    pushPrompt: {
      title: "Enable notifications",
      message: "Enable push notifications to receive alerts about your groups and competitions.",
      activate: "Enable",
      dismiss: "Not now",
    },
    cookies: {
      toast: {
        disclaimer:
          // eslint-disable-next-line max-len
          "We use our own and third-party cookies to analyse traffic on our website by obtaining the data needed to study your browsing behaviour.",
        configure: "Cookie policy",
        acceptAll: "Accept all",
      },
      cookiesManager: {
        title: "Cookie policy",
        cookiesUsed: "This website uses the following types of cookies:",
        needed: "Necessary",
        neededText:
          // eslint-disable-next-line max-len
          "Cookies strictly necessary to provide a service or content requested by the user. These handle technical aspects such as identifying records and managing tool preferences in the use, interaction and location of access to content.",
        analytics: "Statistics / Analytics",
        analyticsText:
          // eslint-disable-next-line max-len
          "These cookies collect information related to the use of the page such as time spent and content visited by readers to measure performance and improve navigation.",
        accept: "Save preferences",
        acceptAll: "Accept All",
      },
    },
  },
};
